export default "__VITE_ASSET__D2xQe_pU__"